import React, {Component} from 'react'
import fire from './database/firebase'
import {BrowserRouter as Router,Routes,Route,Redirect,useParams} from "react-router-dom";
import Landing from './landing/Landing';
import Login from './login/Login';
import Home from './home/Home';
import Reads from './reads/Reads';
import Saves from './saves/Saves';
import DailyReport from './dailyreport/DailyReport';
import ViewNote from './view-note/ViewNote';

class App extends Component {
  constructor() {
    super()
    this.state = {
      user: null
    }
  }

  componentDidMount = () => {
    this.authListener()
  }

  authListener = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({user})
      } else {
        this.setState({user:null})
      }
    })
  }

  render () {
    return (
      <div className="header">
        {this.state.user ? (
          <Router>
          <Routes>
            <Route path="/home" element={<Home/>}/>
            <Route path="/reads" element={<Reads/>}/>
            <Route path="/saves" element={<Saves/>}/>
            <Route path="/daily-report" element={<DailyReport/>}/>
            <Route path="/view-note" element={<ViewNote/>}/>
          </Routes>
        </Router>
        ):(
          <Router>
          <Routes>
            <Route path="/" element={<Landing/>}/>
            <Route path="/login" element={<Login/>}/>
          </Routes>
        </Router>
        )}
      </div>
    );
  }
}

export default App;
